console.log("Geolocation handler loaded... disableStickyATC:", disableStickyATC);

export const oosCanadaProductIds = [];
export const oosUkProductIds = [];
export const oosUsaProductIds = [];

if (!window.__bartesianGeoScriptLoaded) {
  window.__bartesianGeoScriptLoaded = true;

  const currentUrl = window.location.href;

  for (const key in disableStickyATC) {
    const oosValues = disableStickyATC[key];
    if (oosValues.includes("no_CAN")) oosCanadaProductIds.push(key);
    if (oosValues.includes("no_UK")) oosUkProductIds.push(key);
    if (
      oosValues.includes("no_US") ||
      oosValues.some(
        (value) =>
          value.startsWith("no_") &&
          value !== "no_UK" &&
          value !== "no_CAN"
      )
    ) {
      oosUsaProductIds.push(key);
    }
  }

  let geoDetailsLoading = false;

  async function loadGeoDetails() {
    if (geoDetailsLoading) {
      console.log("loadGeoDetails already in progress or done – skipping");
      return;
    }
    geoDetailsLoading = true;

    console.log("loadGeoDetails called");
    try {
      const storedGeoData = sessionStorage.getItem("geoDetails");
      if (storedGeoData) {
        console.log("Using stored geo details from session storage");
        const data = JSON.parse(storedGeoData);
        handleGeoData(data);
        runPricingUI(data);
        return;
      }

      const response = await fetch("http://ipwhois.pro/?key=yvRfcyIBk5fJAAei");
      const data = await response.json();
      console.log("geolocation-handler data", data);

      if (data.success) {
        console.log("Geo details fetched", data);
        sessionStorage.setItem("geoDetails", JSON.stringify(data));
        handleGeoData(data);
        runPricingUI(data);
      } else {
        console.error("Failed to fetch geolocation data.");
      }
    } catch (e) {
      console.error("Error fetching geolocation data:", e);
    }
  }

  function runPricingUI(data) {
    const pathname = window.location.pathname;
    console.log("pathname", pathname);

    if (pathname.includes("/products")) {
      console.log("initial PDP loading");
      const BartesianPricingUI = document.querySelector("bartesian-pricing-ui");
      if (
        BartesianPricingUI &&
        typeof BartesianPricingUI.checkRegionCodes === "function"
      ) {
        BartesianPricingUI.checkRegionCodes(data);
      } else {
        console.warn(
          "BartesianPricingUI element or checkRegionCodes method not found."
        );
      }
    } else if (pathname.includes("/collections")) {
      console.log("initial PLP loading");
      const BartesianPricingUIs =
        document.querySelectorAll("bartesian-pricing-ui");
      if (BartesianPricingUIs.length > 0) {
        BartesianPricingUIs.forEach((BartesianPricingUI) => {
          if (
            typeof BartesianPricingUI.checkRegionCodes === "function"
          ) {
            BartesianPricingUI.checkRegionCodes(data);
          } else {
            console.warn(
              "checkRegionCodes method not found on an instance of BartesianPricingUI."
            );
          }
        });
      } else {
        console.warn(
          "No BartesianPricingUI elements found on the collections page."
        );
      }
    } else {
      console.log("No matching pathname for PDP or PLP logic.");
    }
  }

  function handleGeoData(data) {
    if (data.country_code === "GB") {
      redirectToUKPage();
    }
  }

  function redirectToUKPage() {
    if (window.location.href.includes("en-gb")) {
      return;
    }

    const pathname = window.location.pathname;
  
    // Only redirect to UK version for the subscriptions page specifically
    if (pathname === "/a/account/subscriptions") {
      window.location.href = `https://bartesian.com/en-gb${pathname}`;
      return;
    }
  
    // Skip redirect for other Skio account pages (login, etc) to avoid breaking auth flow
    if (pathname.includes("/a/account/")) {
      return;
    }
  
    // For all other pages, redirect to UK homepage
    window.location.href = "https://bartesian.com/en-gb";
  }
  

  if (!window.__bartesianGeoInit) {
    window.__bartesianGeoInit = true;
    document.addEventListener("DOMContentLoaded", () => {
      loadGeoDetails();
    });
  } else {
    console.log(
      "Geo handler already initialized, skipping DOMContentLoaded binding"
    );
  }
} else {
  console.log("Geo script already loaded, skipping entire file");
}
